module.exports = __webpack_public_path__ + "static/media/github-tile.0e445768.svg";